var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb--2"},[_c('span',{staticClass:"txt--upper txt--strong txt--sm d--b"},[_vm._v(_vm._s(_vm.title))]),(_vm.value != null)?_c('p',[_vm._v(_vm._s(_vm.value))]):_vm._e(),(_vm.html != null)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }